import { render, staticRenderFns } from "./cadastrar-banco.vue?vue&type=template&id=6532f460&"
import script from "./cadastrar-banco.vue?vue&type=script&lang=js&"
export * from "./cadastrar-banco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports